const ErrorDisplay = ({props}) => {
    return (<div style={{ fontSize: 14, color: '#444', textAlign: 'center', padding: '10px 0px', marginBottom: 10, fontWeight: 'bold' }}>{props}</div>);
}

export default ErrorDisplay;